import { useState } from 'react';
import './back-top.scss';

const BackTop = () => {
  const [isActive, setActive] = useState(false);
  const handleScroll = () => {
    if (window.scrollY > 125) {
      setActive(true);
    } else {
      setActive(false);
    }
  };
  window.addEventListener('scroll', handleScroll);

  const handleScrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      <div
        className={`back-to-top ${isActive ? 'active' : ''}`}
        onClick={handleScrollTop}
      >
        <i className='fa-solid fa-arrow-up'></i>
      </div>
    </>
  );
};

export default BackTop;
